import type { U3204ExportFile } from '../U3204Service';

const U3204_MIME_WORD =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const U3204_MIME_PDF = 'application/pdf';

/** Kind UI aligné attachmentType export (`excel` | `word` | `pdf_export` — ≠ PJ `pdf`). */
export type U3204ExportKind = 'excel' | 'word' | 'pdf_export';

export function u3204ResolveExportKind(exportFile: U3204ExportFile): U3204ExportKind {
  const mime = (exportFile.fileMimeType || '').toLowerCase();
  const name = (exportFile.fileName || '').toLowerCase();
  if (mime === U3204_MIME_PDF || mime.includes('application/pdf') || name.endsWith('.pdf')) {
    return 'pdf_export';
  }
  if (mime.includes('wordprocessingml') || mime === U3204_MIME_WORD || name.endsWith('.docx')) {
    return 'word';
  }
  return 'excel';
}
